import type { ChangeEventHandler } from "react";

interface CheckboxInputProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Visually hide the label (grid cells keep the header as the visible label). */
  hideLabel?: boolean;
  description?: string;
  /** Hover text, for saying why a box is disabled. */
  title?: string;
  children?: never;
}

export function CheckboxInput({ id, label, checked, onChange, disabled, hideLabel, description, title }: CheckboxInputProps) {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => onChange(event.currentTarget.checked);

  return (
    <label htmlFor={id} title={title} className={`inline-flex items-center gap-2 select-none ${disabled ? "cursor-default opacity-60" : "cursor-pointer"} ${hideLabel ? "min-h-[32px] min-w-[32px] justify-center" : ""}`}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        aria-label={hideLabel ? label : undefined}
        className="h-4 w-4 rounded border-gray-300 accent-brand-green focus:outline-none focus:ring-2 focus:ring-brand-green-50"
      />
      {!hideLabel && (
        <span>
          <span className="text-sm text-gray-700">{label}</span>
          {description && <span className="block text-xs text-gray-500">{description}</span>}
        </span>
      )}
    </label>
  );
}
